import React from 'react';
import classnames from 'classnames';
import CollapseElement from '../elements-collapse/Collapse';
import { FormattedMessage } from 'react-intl';

export const CancellationPolicySection = ({
  policyName = '',
  policyDescription = [],
  gracePeriodApplies = false,
  isCollapseOpen
}) => (
  <CollapseElement
    buttonClassname="cancellation-section-btn btn-reset"
    buttonText={
      <PolicyTitle
        policyName={policyName}
        gracePeriodApplies={gracePeriodApplies}
      />
    }
  >
    <div className="cancellation-policy">
      <ul>
        {
          policyDescription.map(desc => (
            <li>{desc}</li>
          ))
        }
      </ul>
    </div>
  </CollapseElement>
);

export const PolicyTitle = ({
  policyName,
  gracePeriodApplies,
  isCollapseOpen
}) => (
  <div className="flex middle space-between">
    <div className="flex-basis-90 text-left">
      <label className="h6 no-top-margin no-bottom-margin capitalize">{``}
        <FormattedMessage
          id='inbox_review_offer.policy_title.cancellation_policy'
          defaultMessage='Cancellation Policy: {name} {period}'
          values={{
            name: policyName,
            period: gracePeriodApplies
              ? <FormattedMessage id='inbox_review_offer.policy_title.with_grace' defaultMessage='with Grace Period' />
              : ''
          }}
        />
      </label>
    </div>
    <div className="flex-basis-15 text-right">
      <i className={classnames('ico ico-md text-gray-800 icon-arrow-nav middle float-right', { 'icon-rotate-180': isCollapseOpen })} />
    </div>
  </div>
);
